import React, { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
// import moment from "moment";

import Footer from "../../../components/layout/Footer";
import {
  handleLogin,
  handleQueryLogin,
  isAuthorised,
  // getRequestTime,
  // sendOtp, validateOtp
} from "../../../services/auth";
import ForgotPassword from "../ForgotPassword";
// import OtpPhase from "../OtpPhase";
import { Mixpanel } from "../../../constants/mixpanel";
import { useLocation } from "react-router-dom";
import { decryptData } from "../../../utils";
import Loader from "../../../components/ui/Loader";
import { toast, ToastContainer } from "react-toastify";
import { useSetRecoilState } from "recoil";
import { currentRole } from "../../../store";
import { Loginform } from "./LoginForm";
import { hop_benefits } from "../../../constants";
import { is } from "cypress/types/bluebird";
import { LoginformNew } from "./LoginFormNew";
import ForgotPasswordNew from "../ForgotPassword/ForgotPasswordNew";

const SignIn = () => {
  const navigate = useNavigate();
  const setRole = useSetRecoilState(currentRole);
  const [isIncorrectPassword, setInorrectPassword] = React.useState<boolean>(false);
  const [isUserRegistered, setIsUserRegistered] = React.useState<string>("");
  const [isForgotPassword, setIsForgotPassword] = React.useState<boolean>(false);
  const [, saveUserData] = React.useState({ email: "", password: "" });
  const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [signInError, setSignInError] = React.useState<string>("");
  const [isCheckingSession, setIsCheckingSession] = React.useState<boolean>(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryid = queryParams.get("id");

  const decryptedId = decryptData(queryid ? queryid : "");

  const queryLogin = (data: any) => {
    setLoading(true);
    handleQueryLogin({
      queryid: decryptedId,
    })
      .then((response: any) => {
        if (response?.data) {
          const decodedToken: any = jwtDecode(response.data.idToken);
          const { everestPartner } = response && response.data;
          if (decodedToken?.sub?.toLowerCase() === response?.data?.userDetails?.email.toLowerCase()) {
            localStorage.setItem("userKey", response.data.vendor_key);
            localStorage.setItem("userToken", response.data.idToken);
            localStorage.setItem("currentUser", JSON.stringify(response.data));
            localStorage.setItem("everestPartner", everestPartner);
            navigate("/home");
          }
          else {
            toast.error("Given URL is not valid, please try again");
            setTimeout(() => {
              navigate("/auth/sign-in");
            }, 2000);
          }
        }
      })
      .catch((error) => {
        console.error("err", error);
        if (
          error?.response?.Message ===
          "The User ID is incorrect, Please try again"
        ) {
          // toast.error("Incorrect Login Credentials");
          toast.error("Given URL is not valid, please try again");
          setTimeout(() => {
            navigate("/auth/sign-in");
          }, 2000);
        }
      })
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    if (queryid) {
      queryLogin({ data: decryptedId });
    }
  }, [queryid]);

  useEffect(() => {
    if (queryid) {
      setIsCheckingSession(false);
      return;
    }

    const redirectIfAuthenticated = async () => {
      const localToken = localStorage.getItem("userToken");
      const sessionToken = sessionStorage.getItem("userToken");

      if (!localToken && !sessionToken) {
        setIsCheckingSession(false);
        return;
      }

      let storedUser: any = null;

      try {
        const rawUser = localStorage.getItem("currentUser");
        storedUser = rawUser ? JSON.parse(rawUser) : null;
      } catch (error) {
        storedUser = null;
      }

      if (!storedUser || Object.keys(storedUser).length === 0) {
        localStorage.removeItem("userKey");
        localStorage.removeItem("userToken");
        localStorage.removeItem("currentUser");
        localStorage.removeItem("everestPartner");
        localStorage.removeItem("isMasterVendor");
        localStorage.removeItem("lanMandatory");
        sessionStorage.removeItem("userToken");
        setIsCheckingSession(false);
        return;
      }

      try {
        await isAuthorised(storedUser);
        navigate("/home", { replace: true });
      } catch (error) {
        localStorage.removeItem("userKey");
        localStorage.removeItem("userToken");
        localStorage.removeItem("currentUser");
        localStorage.removeItem("everestPartner");
        localStorage.removeItem("isMasterVendor");
        localStorage.removeItem("lanMandatory");
        sessionStorage.removeItem("userToken");
      } finally {
        setIsCheckingSession(false);
      }
    };

    void redirectIfAuthenticated();
  }, [navigate, queryid]);


  const onLogin = (data: any) => {
    setLoading(true);
    handleLogin({
      email: data.email,
      password: data.password,
      isOtpVerified: true,
    })
      .then((response: any) => {
        if (response?.data) {
          const decodedToken: any = jwtDecode(response.data.idToken);
          const { username, partner_type, vendor_key, phoneNumber, everestPartner } = response && response.data;
          if (username && phoneNumber) {
            Mixpanel.identify(phoneNumber);
            Mixpanel.identify(phoneNumber);
            const mixpanelProps = {
              username: username,
              $email: username,
              email: username,
              partner_type: partner_type,
              vendor_key: vendor_key,
            };
            Mixpanel.people.set(mixpanelProps);
            Mixpanel.track("Login", mixpanelProps);
          }
          if (decodedToken.sub.toLowerCase() === data.email.toLowerCase()) {
            setInorrectPassword(false);
            localStorage.setItem("userKey", response.data.vendor_key);
            localStorage.setItem("userToken", response.data.idToken);
            localStorage.setItem("currentUser", JSON.stringify(response.data));
            localStorage.setItem("everestPartner", everestPartner);
            isAuthorised(response.data)
            .then((data) => {
              if (data?.data?.isMasterVendor) {
                localStorage.setItem("isMasterVendor", data?.data?.isMasterVendor);
              }
              localStorage.setItem("lanMandatory", data?.data?.lanMandatory);
            })
            .catch(() => {
              navigate("/auth/sign-in");
            });
            const jwtToken = response.data.idToken;
            const payLoad = jwtDecode<any>(jwtToken);
            setRole(payLoad?.Role);
            // setActiveStep(2);
            navigate("/home");
          }
        }
      })
      .catch((error) => {
        console.error("err", error);
        if (
          error?.response?.Message ===
          "The user name and/or password are incorrect, Please try again"
        ) {
          setIsUserRegistered("Incorrect Email");
          setIsUserRegistered("");
          setSignInError("Incorrect Password/Email");
          setInorrectPassword(true);
        }
        if (error?.response?.data?.Message === "Vendor details not found") {
          setIsUserRegistered(error?.response?.data?.Message);
          setSignInError(error?.response?.data?.Message);
          setInorrectPassword(false);
        }
      })
      .finally(() => setLoading(false));
  };

  const handleClickedLogin = (data: any) => {
    onLogin(data);
  };


  return (
    queryid ? <>
      <ToastContainer position="top-center" /><Loader /></> :
      isCheckingSession ? <Loader /> :
      <>
      {/* Old UI */}

        <Loginform
          isUserRegistered={isUserRegistered}
          isIncorrectPassword={isIncorrectPassword}
          setIsForgotPassword={setIsForgotPassword}
          setInorrectPassword={setInorrectPassword}
          setIsUserRegistered={setIsUserRegistered}
          saveUserData={saveUserData}
          isDisabled={isDisabled}
          setIsDisabled={setIsDisabled}
          handleClickedLogin={handleClickedLogin}
          signInError={signInError}
          loading={loading}
        />

        <ForgotPassword
          isForgotPassword={isForgotPassword}
          setIsForgotPassword={setIsForgotPassword}
        />

        {/* New UI */}

        {/* {!isForgotPassword && <LoginformNew
            isUserRegistered={isUserRegistered}
            isIncorrectPassword={isIncorrectPassword}
            setIsForgotPassword={setIsForgotPassword}
            setInorrectPassword={setInorrectPassword}
            setIsUserRegistered={setIsUserRegistered}
            saveUserData={saveUserData}
            isDisabled={isDisabled}
            setIsDisabled={setIsDisabled}
            handleClickedLogin={handleClickedLogin}
            signInError={signInError}
            loading={loading}
          />}
        {isForgotPassword &&
            <ForgotPasswordNew
              setIsForgotPassword={setIsForgotPassword}
            />
          } */}
      </>
  );
};

export default SignIn;
